import { CommonResponse, UnitTypeEnum } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { StockReceiveDto } from '../dto/stock-receive.dto';
import { StockTransferDto } from '../dto/stock-transfer.dto';
import { ProductionInventoryRepository } from '../repositories/production-inventory.repository';
import { ProductionLogRepository } from '../repositories/production-log.repository';
import { StockTransferLogRepository } from '../repositories/stock-transfer-log.repository';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { ErrorResponse, FgStatusEnum, GlobalVariableValues, InventoryTypeEnum, JobCompletedEnum, TransferStatusEnum, WorkStationTypeEnum } from '@gtpl/shared-models/common-models';
import { ProductionLog } from '../entities/production-log.entity';
import { StockTransferLog } from '../entities/stock-transfer-log';
import { getManager, IsNull, Not } from 'typeorm';
import { AllReceiveSubplantStockResponseModel, ReceiveSubplantStockDto } from '@gtpl/shared-models/production-management';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { UnitRequest } from '../dto/unit.id.request';
import { UnitcodeService } from '@gtpl/shared-services/masters';
import appSettings from 'apps/services/config';
@Injectable()
export class StockTransferService {
    constructor(@InjectRepository(ProductionInventoryRepository)
    private inventoryRepository: ProductionInventoryRepository,
    private saleOrderService: SaleOrderService,
    @InjectRepository(ProductionLogRepository)
    private logRepository: ProductionLogRepository,
    @InjectRepository(StockTransferLogRepository)
    private stockTransferLogRepository: StockTransferLogRepository,
    private unitcodeService: UnitcodeService
    ){ }

    /**
     * This service will send stock from plant to another plant
     * @param inputReq 
     */
     async sendStock(inputReq: StockTransferDto[]): Promise<CommonResponse> {
        console.log(inputReq);
        const manager = new GenericTransactionManager();
        try
        {
            let flag = true;
            await manager.startTransaction();
            const dcNoMap = new Map<string,string>();
            for(const record of inputReq){
                let fromPlantType =  await this.unitcodeService.getPlantDetailsById({unitcodeId:record.plantId});
                let toPlantType =  await this.unitcodeService.getPlantDetailsById({unitcodeId:record.subPlantId});
                let inventoryplantIdType =  await this.unitcodeService.getPlantDetailsById({unitcodeId:record.inventoryplantId});
                const productionInvRecord = await manager.getCustomRepository(ProductionInventoryRepository).findOne({productionInventoryId:record.prodInvId,lotNumber:record.lotNo,subLotNumber:record.subLotNo,operation:record.operation,nextOperation:record.nextOperation});

                let plant;
                let subPlant;

                if(fromPlantType.data.plantType === "PLANT" && toPlantType.data.plantType === "SUB PLANT"){
                    plant = record.inventoryplantId;
                    subPlant = record.subPlantId;
                }
                else if(fromPlantType.data.plantType === "PLANT" && toPlantType.data.plantType === "PLANT"){
                    plant = record.subPlantId;
                    subPlant = 0;
                }
                else if(fromPlantType.data.plantType === "SUB PLANT" && toPlantType.data.plantType === "PLANT"){
                    plant = record.subPlantId;
                    subPlant = 0;
                }
                else if(fromPlantType.data.plantType === "SUB PLANT" && toPlantType.data.plantType === "SUB PLANT"){
                    plant = record.inventoryplantId;
                    subPlant = record.subPlantId;
                }
                let newProdInvRecord;
                let newProductInvId;

                let checkProductInventory 
                if(GlobalVariableValues.productionVersion == 'V1'){
                    checkProductInventory =  await manager.getCustomRepository(ProductionInventoryRepository).findOne({
                    saleOrderId:productionInvRecord.saleOrderId,saleOrderItemId:productionInvRecord.saleOrderItemId,lotNumber:record.lotNo,operation:record.operation,nextOperation:record.nextOperation,plantId:plant,subPlantId:subPlant});

                }else{
                    checkProductInventory =  await manager.getCustomRepository(ProductionInventoryRepository).findOne({
                    lotNumber:record.lotNo,prevOperation:record.previousOperation,operation:record.operation,plantId:plant,subPlantId:subPlant});
                }
                

                if(checkProductInventory != undefined){
                    newProdInvRecord = await manager.getCustomRepository(ProductionInventoryRepository).update({productionInventoryId:checkProductInventory.productionInventoryId}, {intransitQuantity:()=>`intransit_quantity+${record.quantity}`,updatedUser:record.createdUser});
                    newProductInvId = checkProductInventory.productionInventoryId;
                }
                else{
                    let prodInvRecord
                    if(GlobalVariableValues.productionVersion == 'V1'){
                        prodInvRecord = await manager.getCustomRepository(ProductionInventoryRepository).findOne({productionInventoryId:record.prodInvId,lotNumber:record.lotNo,subLotNumber:record.subLotNo,operation:record.operation,nextOperation:record.nextOperation});
                    }else{
                        prodInvRecord = await manager.getCustomRepository(ProductionInventoryRepository).findOne({productionInventoryId:record.prodInvId,lotNumber:record.lotNo,subLotNumber:record.subLotNo,operation:record.operation});
                    }
                    if(!prodInvRecord){
                        await manager.releaseTransaction();    
                        throw new ErrorResponse(10000,'Production inventory not found');
                    }
                    delete prodInvRecord.productionInventoryId;
                    
                    if(fromPlantType.data.plantType === "PLANT" && toPlantType.data.plantType === "SUB PLANT"){
                        prodInvRecord.plantId = record.inventoryplantId;
                        prodInvRecord.subPlantId = record.subPlantId;
                    }
                    else if(fromPlantType.data.plantType === "PLANT" && toPlantType.data.plantType === "PLANT"){
                        prodInvRecord.plantId = record.subPlantId;
                        prodInvRecord.subPlantId = 0;
                    }
                    else if(fromPlantType.data.plantType === "SUB PLANT" && toPlantType.data.plantType === "PLANT"){
                        prodInvRecord.plantId = record.subPlantId;
                        prodInvRecord.subPlantId = 0;
                    }
                    else if(fromPlantType.data.plantType === "SUB PLANT" && toPlantType.data.plantType === "SUB PLANT"){
                        prodInvRecord.plantId = record.inventoryplantId;
                        prodInvRecord.subPlantId = record.subPlantId;
                    }
                    prodInvRecord.status = FgStatusEnum.OPEN;
                    prodInvRecord.createdUser = record.createdUser;            
                    prodInvRecord.stockTransferQty = 0;
                    prodInvRecord.boxes = 0;
                    prodInvRecord.issuedQuantity = 0;
                    prodInvRecord.intransitQuantity = record.quantity;
                    prodInvRecord.physicalQuantity = 0;
                    prodInvRecord.rejectedQuantity = 0;
                    prodInvRecord.assignedRejection = 0;
                    prodInvRecord.wipQuantity = 0;
                    prodInvRecord.transferedBoxes = 0;
                    prodInvRecord.wastageQuantity = 0;
                    prodInvRecord.wipQuantity = 0;
                    prodInvRecord.opBoxes = 0;
                    prodInvRecord.conversionQuantity = 0;
                    prodInvRecord.convertedBoxes = 0;
                    prodInvRecord.inventoryType = InventoryTypeEnum.Stock_Transfer;
                    newProdInvRecord = await manager.getCustomRepository(ProductionInventoryRepository).save(prodInvRecord);
                    newProductInvId = newProdInvRecord.productionInventoryId;
                }
                // const productionLogObj = new ProductionLog();
                // productionLogObj.lotNumber = record.lotNo;
                // productionLogObj.subLotNumber = record.subLotNo;
                // productionLogObj.saleOrderId = newProdInvRecord.saleOrderId;
                // productionLogObj.saleOrderItemId = newProdInvRecord.saleOrderItemId;
                // productionLogObj.operationType = newProdInvRecord.nextOperation;
                // // job number generation 
                const today = new Date();
                const CurrentYear = today.getFullYear();
                const CurrentMonth = today.getMonth();
                let fromDate = 0;
                let toDate = 0;
                // let totalRecords = await (await this.logRepository.find({where:{operationType:newProdInvRecord.operationCategory}})).length;
                    if (CurrentMonth < 4) {
                        fromDate = (CurrentYear);
                        toDate = (CurrentYear + 1);
                    } else {
                        fromDate = (CurrentYear);
                        toDate = (CurrentYear + 1);
                    }

                // totalRecords = totalRecords + 1;

                // let refNo = totalRecords + "";
                // while (refNo.length < 4) refNo = "0" + refNo;

                // const GradingJobNo = newProdInvRecord.nextOperation + (fromDate.toString().substr(-2))+"-"+(toDate.toString().substr(-2)) + "/" + refNo;

                // productionLogObj.jobNumber = GradingJobNo;
                // productionLogObj.plantId = record.inventoryplantId;

                // if(fromPlantType.data.plantType === "PLANT" && toPlantType.data.plantType === "SUB PLANT"){
                //     productionLogObj.plantId = record.inventoryplantId;
                //     productionLogObj.subPlantId = record.subPlantId;
                // }
                // else if(fromPlantType.data.plantType === "PLANT" && toPlantType.data.plantType === "PLANT"){
                //     productionLogObj.plantId = record.subPlantId;
                //     productionLogObj.subPlantId = 0;
                // }
                // else if(fromPlantType.data.plantType === "SUB PLANT" && toPlantType.data.plantType === "PLANT"){
                //     productionLogObj.plantId = record.subPlantId;
                //     productionLogObj.subPlantId = 0;
                // }
                // else if(fromPlantType.data.plantType === "SUB PLANT" && toPlantType.data.plantType === "SUB PLANT"){
                //     productionLogObj.plantId = record.inventoryplantId;
                //     productionLogObj.subPlantId = record.subPlantId;
                // }

                // productionLogObj.workStationType = WorkStationTypeEnum.EXTERNAL;
                // productionLogObj.jobStatus = JobCompletedEnum.NO;
                // productionLogObj.inputGrade = newProdInvRecord.inputGrade;
                // productionLogObj.plannedGrade = newProdInvRecord.inputGrade;
                // productionLogObj.actualGrade = newProdInvRecord.outputGrade;
                // productionLogObj.inputQuantity = record.quantity;
                // productionLogObj.plannedOutputQuantity = record.quantity;
                // productionLogObj.inputBoxes = record.noOfBoxes;
                // productionLogObj.assignedUser = record.createdUser;
                // productionLogObj.createdUser = record.createdUser;
                // productionLogObj.prodInvId = newProdInvRecord.productionInventoryId;
                // productionLogObj.assignedTime = new Date();
                // productionLogObj.reportedTime = new Date();
                // const newProductionLogRecord = await manager.getCustomRepository(ProductionLogRepository).save(productionLogObj);
                const transferLogObj = new StockTransferLog();
                transferLogObj.plantId = record.plantId;
                transferLogObj.subPlantId = record.subPlantId;
                transferLogObj.productionInvId = record.prodInvId;
                transferLogObj.sendBoxes = record.noOfBoxes;
                transferLogObj.sendCount = record.count;
                transferLogObj.sendQuantity = record.quantity;
                transferLogObj.createdUser = record.createdUser;
                transferLogObj.estimatedDate = record.estimatedDate
                transferLogObj.newProductionInvId = newProductInvId;
                if(!dcNoMap.has(record.subPlantName)){
                    const noOfRecords = await this.stockTransferLogRepository.count();
                    const dcCount = (noOfRecords.toString().length > 3) ? noOfRecords+1 : ('0000' + (noOfRecords+1)).slice(-4); 
                    transferLogObj.dcNumber = "DC/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + dcCount;
                } else {
                    transferLogObj.dcNumber = dcNoMap.get(record.subPlantName);
                }
                transferLogObj.status = TransferStatusEnum.IN_TRANSIT;
                let saveTransferLog = await manager.getCustomRepository(StockTransferLogRepository).save(transferLogObj);
                console.log(saveTransferLog)
                if(saveTransferLog.transferLogId < 0){
                    flag = false;
                }
                // update production inventory
                let updateInventory
                if(GlobalVariableValues.productionVersion == 'V1'){
                    updateInventory = await manager.getCustomRepository(ProductionInventoryRepository).update({productionInventoryId:record.prodInvId,lotNumber:record.lotNo,subLotNumber:record.subLotNo,operation:record.operation,nextOperation:record.nextOperation}, {transferedBoxes:()=>`transfered_boxes+${record.noOfBoxes}`,stockTransferQty:()=>`stock_transfer_qty+${record.quantity}`,updatedUser:record.createdUser});
                }else{
                    updateInventory = await manager.getCustomRepository(ProductionInventoryRepository).update({productionInventoryId:record.prodInvId}, {transferedBoxes:()=>`transfered_boxes+${record.noOfBoxes}`,stockTransferQty:()=>`stock_transfer_qty+${record.quantity}`,updatedUser:record.createdUser});
                }
                console.log(updateInventory);
                if(updateInventory.affected <1){
                    flag = false;
                }
            }
            if(!flag){
                await manager.releaseTransaction();
                return new CommonResponse(false,1001,'something went wrong. ');
            }
            else{
                await manager.completeTransaction();
                return new CommonResponse(true,10000,'Stock Transfered Successfully');
            }
        }
        catch (error) {
                await manager.releaseTransaction();
                console.log(error)
                return error
            }
        }

    /**
     * This service will receive stock from different plants
     * @param inputReq 
     */
     async receiveStock(inputReq: StockReceiveDto[]): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        await manager.startTransaction();
        for(const record of inputReq){
            const stockTransLogRecord = await manager.getCustomRepository(StockTransferLogRepository).findOne({transferLogId:record.transferLogId});
            if(!stockTransLogRecord){
                await manager.releaseTransaction();    
                throw new ErrorResponse(10000,'Stock transfer record not found');
            }
            const today = new Date();
            const CurrentYear = today.getFullYear();
            const CurrentMonth = today.getMonth();
            let fromDate = 0;
            let toDate = 0;
            if (CurrentMonth < 4) {
                fromDate = (CurrentYear);
                toDate = (CurrentYear + 1);
            } else {
                fromDate = (CurrentYear);
                toDate = (CurrentYear + 1);
            }
            const noOfRecords = await this.stockTransferLogRepository.count({where:{mrnNumber: Not(IsNull())}});
            console.log(noOfRecords);
            const mrnCount = (noOfRecords.toString().length > 3) ? noOfRecords+1 : ('0000' + (noOfRecords+1)).slice(-4);
            console.log(mrnCount);
            const mrnNumber = 'MRN/'+ (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/"+mrnCount;
            console.log(mrnNumber);
            await manager.getCustomRepository(StockTransferLogRepository).update({transferLogId:record.transferLogId},{receiveBoxes:record.receivedBoxes,receviedQuantity:record.receivedQuantity,receviedCount:stockTransLogRecord.sendCount,status:TransferStatusEnum.RECEIVED,updatedUser:record.updatedUser,mrnNumber:mrnNumber, receivedDate:new Date()});

            // const prodInvLogObj = await manager.getCustomRepository(ProductionLogRepository).findOne({productionLogId:stockTransLogRecord.productionLogId});
            // if(!prodInvLogObj){
            //     await manager.releaseTransaction();    
            //     throw new ErrorResponse(10000,'Production log details not found');
            // }            
            // update production log data
            // await manager.getCustomRepository(ProductionLogRepository).update({productionLogId:stockTransLogRecord.productionLogId}, {jobStatus: JobCompletedEnum.YES,actualOutputQuantity:record.receivedQuantity,outputBoxes: record.receivedBoxes,reportedTime: new Date(),updatedUser:record.updatedUser});

            // update production inventory
            await manager.getCustomRepository(ProductionInventoryRepository).update({productionInventoryId:stockTransLogRecord.newProductionInvId}, {boxes:()=>`boxes+${record.receivedBoxes}`,opBoxes:()=>`op_boxes+${record.receivedBoxes}`,physicalQuantity:()=>`physical_quantity+${record.receivedQuantity}`,intransitQuantity:()=>`intransit_quantity-${record.receivedQuantity}`,updatedUser:record.updatedUser});
        }        
        await manager.completeTransaction();
        return new CommonResponse(true,10000,'Stock Recevied Successfully');
    }

    async getAllReceiveSubplantStock(plantReq:UnitRequest): Promise<AllReceiveSubplantStockResponseModel> {
        try{
            // const stockTransferData:ReceiveSubplantStockDto[] = await this.stockTransferLogRepository.createQueryBuilder('stock_transfer_log')
            // .select('stock_transfer_log.transfer_log_id as transferLogId, stock_transfer_log.production_log_id as productionLogId, stock_transfer_log.plant_id as plantId,stock_transfer_log.dc_number as dcNumber,stock_transfer_log.mrn_number as mrnNumber, stock_transfer_log.send_boxes as sendBoxes,stock_transfer_log.receive_boxes as receiveBoxes,stock_transfer_log.send_count as sendCount,stock_transfer_log.send_quantity as sendQuantity,stock_transfer_log.received_count as receivedCount,stock_transfer_log.recevied_quantity as receviedQuantity,stock_transfer_log.status as status,stock_transfer_log.sub_plant_id as subPlantId, productionLog.operationType as operation, productionLog.sale_order_id as saleOrderId, productionLog.input_grade as inputGrade,stock_transfer_log.is_active as isActive,stock_transfer_log.created_user as createdUser,productionLog.job_number as jobNumber, productionLog.job_status as jobStatus')
            // .leftJoin('production_log', 'productionLog','productionLog.production_log_id  = stock_transfer_log.production_log_id')
            // .where(`stock_transfer_log.sub_plant_id='${plantReq.unitId}' and stock_transfer_log.status='${TransferStatusEnum.IN_TRANSIT}'`)
            // .getRawMany();

            // const data: ReceiveSubplantStockDto[] = [];
            // for(const record of stockTransferData){
            //     const soInfo = await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: record.saleOrderId })
            //     const plantDetails = await this.unitcodeService.getPlantDetailsById({unitcodeId:record.plantId});
            //     const fromPlant = plantDetails.status?plantDetails.data.unitcodeName:"";

            //     const toPlantDetails = await this.unitcodeService.getPlantDetailsById({unitcodeId:record.subPlantId});
            //     const toPlant = toPlantDetails.status?toPlantDetails.data.unitcodeName:"";
            //     record.soNumber = soInfo.saleOrderNumber;
            //     record.poNumber = soInfo.poNumber;
            //     record.fromPlant = fromPlant;
            //     record.toPlant = toPlant;
               
                const manager = getManager();
                const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantReq.unitId;
                const result =await manager.query(query);
                const versionBasedOperationColumn = GlobalVariableValues.productionVersion == 'V2' ? 'pinv.operation' : 'pinv.next_operation'
                const versionBasesLotCode = GlobalVariableValues.productionVersion == 'V2' ? `pinv.lot_number` : `CONCAT (gi.lot_number,IF(gi.remarks IS NOT NULL,'-',''),IF(gi.remarks IS NOT NULL,gi.remarks,''))`
                var dataQuery = `SELECT ${versionBasesLotCode} as lotandplantlot,stock_transfer_log.received_date AS mrnDate,stock_transfer_log.created_at AS date, stock_transfer_log.transfer_log_id as transferLogId, stock_transfer_log.production_log_id as productionLogId, stock_transfer_log.plant_id as plantId,stock_transfer_log.dc_number as dcNumber,stock_transfer_log.mrn_number as mrnNumber, stock_transfer_log.send_boxes as sendBoxes,stock_transfer_log.receive_boxes as receiveBoxes,stock_transfer_log.send_count as sendCount,stock_transfer_log.send_quantity as sendQuantity,stock_transfer_log.received_count as receivedCount,stock_transfer_log.recevied_quantity as receviedQuantity,stock_transfer_log.status as status,stock_transfer_log.sub_plant_id as subPlantId, ${versionBasedOperationColumn} as operation, pinv.sale_order_id as saleOrderId, pinv.input_grade as inputGrade,stock_transfer_log.is_active as isActive,stock_transfer_log.created_user as createdUser,uc.unit_name as fromPlant , ucs.unit_name as toPlant ,sid.po_number as poNumber, gi.remarks AS remarks,pinv.lot_number AS lotNumber FROM ` + appSettings.production_db + `.stock_transfer_log stock_transfer_log LEFT JOIN `+appSettings.production_db + `.production_inventory pinv ON pinv.prod_inv_id  = stock_transfer_log.production_inv_id LEFT JOIN `+appSettings.rm_procure_db+`.grn_items gi on gi.lot_number=pinv.lot_number LEFT JOIN  `+ appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = pinv.sale_order_id LEFT JOIN `+appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = stock_transfer_log.plant_id LEFT JOIN `+appSettings.masters_db + `.unitcodes ucs ON ucs.unit_code_id = stock_transfer_log.sub_plant_id WHERE stock_transfer_log.sub_plant_id= `+plantReq.unitId;
                // stock_transfer_log.status='${TransferStatusEnum.IN_TRANSIT}' AND
                // if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
                //     dataQuery += "AND stock_transfer_log.sub_plant_id="+plantReq.unitId;
                //   }else{
                //     dataQuery += "AND stock_transfer_log.plant_id="+plantReq.unitId+' and stock_transfer_log.sub_plant_id = 0';
                //   }
                  const stockTransferData =await manager.query(dataQuery);
            if(stockTransferData.length>0){
                return new AllReceiveSubplantStockResponseModel(true, 1001, "Stock Transfer details retrived successfully. ",stockTransferData);
            }
            else{
                return new AllReceiveSubplantStockResponseModel(false, 1010, "No stock transfer data found. ");
            }
        }
        catch (error) {
            return error
        }
    }

}
